import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import { User } from "../companies/styles";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import { extractEconomicGroupsFromCompanies } from "../../../utils/utils";
import { setEconomicGroups } from "../../../store/slices/b2b/b2bCompanies.slice";
import { setContract, setContractContactsNew } from "../../../store/slices/b2b/b2bContracts.slice";
import { fetchCompanies, getAllPlans, getEconomicGroup, saveContract } from "../../../store/middleware";

const emptyFilter = {
  pageNumber: 1,
  pageSize: 999,
  socialName: "",
  fantasyName: "",
  documentNumber: "",
  economicGroupId: "",
  registerDateFrom: "",
  registerDateTo: "",
  active: "",
  responsibleName: "",
  responsibleEmail: "",
};

function ContractForm({ setShowContractForm, children }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allPlans } = useSelector((state) => state.genericReducer);
  const { companies, economicGroups } = useSelector((state) => state.b2bCompaniesReducer);
  const { contract, contractContactsNew } = useSelector((state) => state.b2bContractsReducer);

  const [id, setId] = useState(0);
  const [code, setCode] = useState("");
  const [active, setActive] = useState(true);
  const [endDate, setEndDate] = useState("");
  const [companyId, setCompanyId] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [description, setDescription] = useState("");
  const [contractPlans, setContractPlans] = useState([]);
  const [companiesState, setCompaniesState] = useState([]);
  const [economicGroupId, setEconomicGroupId] = useState(0);
  const [newEconomicGroups, setNewEconomicGroups] = useState([]);
  const [validations, setValidations] = useState({ open: false, dialogMsg: "", dialogTitle: "" });

  const loadInfos = async () => {
    await dispatch(fetchCompanies(emptyFilter));
    const extractEconomicGroups = extractEconomicGroupsFromCompanies(companies);
    dispatch(setEconomicGroups(extractEconomicGroups));

    const arrayEconomicGroupss = await dispatch(getEconomicGroup({ name: "", code: "", active: "", description: "" }));
    setNewEconomicGroups(arrayEconomicGroupss);

    if (contract?.id && contract?.economicGroupId) {
      const economicGroup = economicGroups.find((item) => {
        return parseInt(item.id) === parseInt(contract?.economicGroupId);
      });
      setCompaniesState(economicGroup?.companies);
    } else {
      setCompaniesState(companies);
    }
    await dispatch(getAllPlans());
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (contract && contract.id > 0 && contract.id !== id) {
      setId(contract.id);
      setCode(contract.code);
      setActive(contract.active);
      setEndDate(contract.endDate);
      setCompanyId(contract.companyId);
      setStartDate(contract.startDate);
      setDescription(contract.description);
      setContractPlans(contract.contractPlans);
      setEconomicGroupId(contract.economicGroupId);
    }
    // eslint-disable-next-line
  }, []);

  const validateForm = () => {
    contractContactsNew.map((item) => {
      if (!item.name) {
        return setValidations({ open: true, dialogMsg: "Required Name", dialogTitle: "ERROR" });
      }
      if (!item.email) {
        return setValidations({ open: true, dialogMsg: "Required Email", dialogTitle: "ERROR" });
      }
      if (!item.gender) {
        return setValidations({ open: true, dialogMsg: "Required Gender", dialogTitle: "ERROR" });
      }
      if (!item.timezone) {
        return setValidations({ open: true, dialogMsg: "Required Timezone", dialogTitle: "ERROR" });
      }
      if (!item.address) {
        return setValidations({ open: true, dialogMsg: "Required Address", dialogTitle: "ERROR" });
      }
      if (item.userPhones.length === 0) {
        return setValidations({ open: true, dialogMsg: "Required Telephone", dialogTitle: "ERROR" });
      }
    });

    if (code === "") {
      setValidations({ open: true, dialogMsg: "Required number of contract", dialogTitle: "ERROR" });
      return false;
    }

    if (description === "") {
      setValidations({ open: true, dialogMsg: "Required description", dialogTitle: "ERROR" });
      return false;
    }

    if (companyId === 0) {
      setValidations({ open: true, dialogMsg: "Necessary economic group", dialogTitle: "ERROR" });
      return false;
    }

    if (startDate === "") {
      setValidations({ open: true, dialogMsg: "Necessary Start", dialogTitle: "ERROR" });
      return false;
    }

    if (endDate === "") {
      setValidations({ open: true, dialogMsg: "Necessary End", dialogTitle: "ERROR" });
      return false;
    }

    return true;
  };

  const addField = (e) => {
    e.preventDefault();
    setContractPlans((state) => [...state, { planId: "", quantity: 1 }]);
  };

  const removeField = (e, findIndex) => {
    e.preventDefault();
    setContractPlans(contractPlans.filter((value, i) => i !== findIndex));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = name === "active" ? !active : e.target.value;

    switch (name) {
      case "code":
        setCode(value);
        break;
      case "companyId":
        setCompanyId(value);
        break;
      case "active":
        setActive(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "startDate":
        setStartDate(value);
        break;
      case "endDate":
        setEndDate(value);
        break;

      default:
        break;
    }
  };

  const handleChangeEconomicGroup = (e) => {
    const id = e.target.value;
    const economicGroup = economicGroups.find((item) => {
      return parseInt(item.id) === parseInt(id);
    });

    if (!economicGroup) return;

    setEconomicGroupId(economicGroup.id);
    setCompaniesState(economicGroup.companies);
    setCompanyId(economicGroup.companies[0].id);
  };

  const handleBack = () => {
    setShowContractForm(false);
    dispatch(
      setContract({
        code: "",
        description: "",
        companyId: 0,
        startDate: "",
        endDate: "",
        active: true,
        contractPlans: [],
        contractContacts: [],
      }),
    );
    dispatch(setContractContactsNew([]));
  };

  const handleChangeContractPlans = (e, index) => {
    const { name, value } = e.target;

    setContractPlans((state) => state.map((item, i) => (i === index ? { ...item, [name]: value } : item)));
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const newContract = {
        ...contract,
        id,
        companyId,
        description,
        endDate,
        startDate,
        code,
        economicGroupId,
        companies: companiesState,
        contractPlans,
        active,
      };

      dispatch(
        saveContract({
          ...newContract,
          contractContactsNew,
        }),
      )
        .then(() => {
          setShowContractForm(false);
          dispatch(
            setContract({
              code: "",
              description: "",
              companyId: 0,
              startDate: "",
              endDate: "",
              active: true,
              contractPlans: [],
              contractContacts: [],
            }),
          );
          dispatch(setContractContactsNew([]));
        })
        .catch((err) => {
          console.log("Failed to save the contract.", err);
        });
    }
  };

  return (
    <User>
      <div className="bigBox bigBoxForm" style={{ paddingLeft: "100px" }}>
        <form className="formulario" style={{ margin: "0" }}>
          <h2>
            {id && id > 0 ? t("EDIT") : t("ADD_NEW")} {t("CONTRACT")}
          </h2>
          <div className="lineInputs">
            <div>
              <label>{t("CONTRACT_NUMBER")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="code" value={code} onChange={handleChange} />
          </div>

          <div className="lineInputs">
            <div>
              <label>{t("DESCRIPTION")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="description" value={description} onChange={handleChange} />
          </div>

          <div className="lineInputs">
            <div>
              <label>{t("ECONOMIC_GROUP")}</label>
              <span>{t("REQUIRED")}</span>
            </div>

            <select
              name="economicGroupId"
              className="input-lingo"
              value={economicGroupId}
              onChange={handleChangeEconomicGroup}
            >
              <option>Select</option>
              {newEconomicGroups?.map((item) => {
                return (
                  <option key={item?.id} value={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div>
            <div>
              <label>{t("LEGAL_NAME")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <select value={companyId} onChange={handleChange} className="input-lingo" name="companyId">
              <option>Select</option>
              {companiesState?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInputs period">
            <label>{t("PLANS")}</label>
            <div className="lingos">
              <div className="lingoSelects">
                <div className="linha"></div>
                <div className="selects">
                  <div className="delet">
                    {contractPlans.map((item, index) => {
                      return (
                        <div key={index * 7}>
                          <div>
                            {t("PLAN")} #{index + 1}
                            <SCButtonAddInput
                              ml="12px"
                              name="remove"
                              data-index={index}
                              onClick={(e) => removeField(e, index)}
                            >
                              Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                            </SCButtonAddInput>
                          </div>

                          <div style={{ display: "flex" }}>
                            <div className="lineInputs" style={{ flex: "1 0 auto", marginRight: "20px" }}>
                              <div>
                                <label>{t("PLAN")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>

                              <select
                                onChange={(e) => handleChangeContractPlans(e, index)}
                                data-index={index}
                                data-id={item.plan ? item.plan.id : null}
                                value={item.planId}
                                name="planId"
                              >
                                <option>Select</option>
                                {allPlans
                                  ?.filter((plan) => plan.active)
                                  ?.map((p) => {
                                    return (
                                      <option key={p.id} value={p.id}>
                                        {p.nameEnglish}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                            <div className="lineInputs" style={{ flex: "1 0 auto" }}>
                              <div>
                                <label>{t("STUDENTS")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>
                              <input
                                type="text"
                                className={`quantity_${index}`}
                                style={{ width: "150px" }}
                                name="quantity"
                                data-index={index}
                                value={item.quantity}
                                onChange={(e) => handleChangeContractPlans(e, index)}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div>
                      {contractPlans?.length < allPlans?.length && (
                        <SCButtonAddInput background="#004fff" color="#fff" onClick={(e) => addField(e)}>
                          {t("BTN_ADD_NEW_PLAN")} +
                        </SCButtonAddInput>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lineInputs period">
            <label>{t("PERIOD")}</label>
            <div className="lingos">
              <div className="lingoSelects">
                <div className="selects" style={{ flexDirection: "row" }}>
                  <div className="lineInputs" style={{ marginRight: "20px" }}>
                    <div>
                      <label>{t("START")}</label>
                      <span>{t("REQUIRED")}</span>
                    </div>
                    <input
                      style={{ width: "200px" }}
                      type="date"
                      name="startDate"
                      value={startDate}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="lineInputs">
                    <div>
                      <label>{t("END")}</label>
                      <span>{t("REQUIRED")}</span>
                    </div>
                    <input
                      style={{ width: "200px" }}
                      type="date"
                      name="endDate"
                      value={endDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {children}

          <div>
            <label>Status</label>
            <div className="switchBox">
              <div className="switch__container">
                <input
                  id="switch-shadow"
                  className="switch switch--shadow"
                  name="active"
                  type="checkbox"
                  checked={active}
                  onChange={handleChange}
                />
                <label htmlFor="switch-shadow">
                  <span style={{ marginLeft: "50px", fontSize: "12px" }}>{active ? "Active" : "Inactive"}</span>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="form-buttons">
        <button type="button" className="btn-back" onClick={handleBack}>
          <i className="fa fa-angle-left" aria-hidden="true"></i>
          {t("BTN_BACK")}
        </button>
        <button type="submit" className="btn-save" onClick={handleSubmit}>
          {t("SAVE")}
        </button>
      </div>

      <Dialog
        open={validations.open}
        keepMounted
        onClose={() => setValidations({ open: false, dialogMsg: "", dialogTitle: "" })}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        className="boxModal"
      >
        <DialogTitle id="alert-dialog-slide-title" className="boxModal">
          {validations.dialogTitle}
        </DialogTitle>
        <DialogContent className="boxModal">
          <DialogContentText id="alert-dialog-slide-description">{validations.dialogMsg}</DialogContentText>
        </DialogContent>
        <DialogActions className="boxModal">
          <Button onClick={() => setValidations({ open: false, dialogMsg: "", dialogTitle: "" })} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </User>
  );
}

export default ContractForm;
